// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import React from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export type { Category } from './types.ts';

import { LoadingCategories, LoadingInlineCategories } from './LoadingCategories.tsx';
import type { Category } from './types.ts';

export const CategorySelector: LoadableType<{
	categories: Category[];
	selectedCategoryIds?: (string | null | undefined)[];
	numVisibleCategories?: number;
	isDisabled?: boolean;
	isLoading?: boolean;
	onCategorySelected?: (category: Category) => void;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CategorySelector" */ './CategorySelector.tsx'))
			.CategorySelector,
	loading: () => <LoadingCategories />,
});

export const InlineCategorySelector: LoadableType<{
	categories: Category[];
	selectedCategoryIds?: (string | null | undefined)[];
	isDisabled?: boolean;
	isLoading?: boolean;
	onCategorySelected?: (category: Category, isDefaultVisible: boolean) => void;
	onCollapsed?: (isCollapsed: boolean) => void;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-InlineCategorySelector" */ './InlineCategorySelector.tsx'
			)
		).InlineCategorySelector,
	loading: () => <LoadingInlineCategories />,
});
